import React, {Component,PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form'
import {Row, Form,Divider,Input } from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';

class SettingsAddEditForm extends PureComponent {
    constructor(props) {
        super(props);
        //---- Detect Add or Edit module
        this.state = {
            formLayout: 'horizontal',
            itemValues: []
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentDidMount () {
        this.props.getItem((status) => {
            if(status) {
                if(this.props.initialValues)
                this.setState({itemValues: this.props.initialValues})
            }
        })
        
    }

    handleChange = index => (event) => {
        const val = event.target.value;
        this.setState(state => {
            const itemValues = state.itemValues.map((item, j) => {
              if (j === index) {
                item.value = val;
                return item;
              } else {
                return item;
              }
            });
            return {
                itemValues,
            };
          });
    }

    render() {
        const {formLayout} = this.state;
        let dataSource = [];
        const { itemValues } = this.state;

        for(let i=0 ; i<this.state.itemValues.length ; i++){
            dataSource.push(
                <div key={i}>
                    <RTLCol className="formLabel" md={6} sm={24}>
                        <label>{itemValues[i].title}</label>
                    </RTLCol>
                    <RTLCol className="formLabel" md={18} sm={24}>
                        <Input
                            name={itemValues[i].const}
                            type="text"
                            placeholder={itemValues[i].title}
                            key={i}
                            defaultValue={itemValues[i].value}
                            value={itemValues[i].value || ''}
                            style={{marginBottom:10}}
                            onChange={this.handleChange(i)}
                        />
                        <span className="settingsHelp">
                            {itemValues[i].help}
                        </span>
                    </RTLCol>
                </div>

            );
        }

        return (
            <Form layout={formLayout} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">تنظیمات</Divider>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>
                            {dataSource}
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                ایجاد
                            </RTLButton>
                            <RTLButton href="#/" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default SettingsAddEditForm = reduxForm({
    form: 'addSetting',        // <--- a unique name for the form
})(SettingsAddEditForm)
